import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import type { OtTabType } from '@1trading/design-system';
import { computed, type PropType } from 'vue';
import { useI18n } from 'vue-i18n';

import futuresFeatureFlagService from '@exchange/libs/futures/service/src/lib/futures-feature-flag.service';
import { MarketType } from '@exchange/libs/market/service/src/lib/market-model';
import { CONSTANTS } from '@exchange/libs/utils/constants/src';

type FilterTab = OtTabType<string>;


export default /*#__PURE__*/_defineComponent({
  __name: 'MarketListFilters',
  props: {
  activeMarketTypeFilter: { type: String, required: true },
  variant: { type: String as PropType<'dark-medium' | 'default'>, required: true },
},
  emits: ["market-type-filter-selected"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const { t } = useI18n({ useScope: 'global' });

const { isEnabled: isFuturesEnabled } = futuresFeatureFlagService;

const isActive = (tabId: string): boolean => props.activeMarketTypeFilter === tabId;

const tabs = computed(() => [
  {
    getTitle: () => '',
    id: CONSTANTS.CURRENCY_FILTER_FAVORITES,
    icon: 'bookmark',
    active: isActive(CONSTANTS.CURRENCY_FILTER_FAVORITES),
  },
  {
    getTitle: () => t('fundamentals.currencies.all'),
    id: CONSTANTS.CURRENCY_FILTER_ALL,
    active: isActive(CONSTANTS.CURRENCY_FILTER_ALL),
  },
  {
    getTitle: () => 'Spot',
    id: MarketType.SPOT,
    active: isActive(MarketType.SPOT),
  },
  ...(isFuturesEnabled.value
    ? [
        {
          getTitle: () => 'Perp',
          id: MarketType.PERP,
          active: isActive(MarketType.PERP),
        },
      ]
    : []),
]);

const onTabSelected = (tab: FilterTab): void => {
  emit('market-type-filter-selected', tab.id);
};

return (_ctx: any,_cache: any) => {
  const _component_ot_tabs = _resolveComponent("ot-tabs")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["market-list-filters", [`market-list-filters--${__props.variant}`]])
  }, [
    _createVNode(_component_ot_tabs, {
      tabs: tabs.value,
      dense: false,
      scrollable: true,
      onTabSelected: onTabSelected
    }, null, 8, ["tabs"])
  ], 2))
}
}

})